import publicationService from 'services/PublicationService';
import { loadSession } from 'data/CurrentUser/sessionManager';
import { dispatch } from 'pluginServices/store';
import { pushToast } from 'containers/ToastManager/actions';
import messages from '../messages';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { sortByDate } from 'Workspace/Publications/utils';

import appConfig from 'appConfig';

const showToastError = (message) => { dispatch(pushToast({ message: intl.formatMessage(message) })); };

export const decodeResponse = async (response) => {
  const reader = response.body.getReader();
  const decoder = new TextDecoder('utf-8');
  let result = '';
  let done = false;

  while (!done) {
    const { value, done: readerDone } = await reader.read();
    done = readerDone;
    result += decoder.decode(value || new Uint8Array(), { stream: !done });
  }

  return result
    .trim()
    .split('\n')
    .map((line) => line.split(',').map((v) => v.trim()));
};

/**
* Fetches SB Media Grid data for a given activity.
* @param {string} activityId - Unique ID of the activity/publication.
* @param {string} outputType - Output type to request from the backend.
* @returns {Promise<Array<Object>>} - Resolves to an array of media grid rows.
* @throws {Error} - If the network request fails or returns invalid data.
*/
export const fetchSBMediaGridData = async (activityId, outputType, market) => {
  try {
    const { publications } = await publicationService.getPublicationHistory(activityId, outputType, market);

    if (!publications?.length) {
      return showToastError(messages.noPublicationHistory);
    }
    // Sort the publictions for the latest one 
    const sortedPublications = sortByDate(publications);
    const { publicationId, cohortId, deploymentId } = sortedPublications[0];

    if (!cohortId || !deploymentId) {
      return showToastError(messages.invalidSBMediaGridOption);
    }

    const token = loadSession();
    const baseUrl = appConfig.getSBMediaGridURL();
    const url = `${baseUrl}${publicationId}`;

    //Fetch the SB Media Grid file
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      if (response.status === 500) {
        return showToastError(messages.internalServerErrorMessage);
      }
      if (response.status === 404) {
        return showToastError(messages.sbMediaGridDownloadFail);
      }
      throw new Error(`Unexpected error: ${response.status}`);
    }

    return await decodeResponse(response);

  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error downloading media import file:', error);
  }
};
